export { default } from "./Delete";
